import { render, staticRenderFns } from "./MenuBarItem.vue?vue&type=template&id=59275ee4&"
import script from "./MenuBarItem.vue?vue&type=script&lang=js&"
export * from "./MenuBarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports